export default {
  FONT_FAMILY: 'Montserrat, sans-serif',
  FONT_WEIGHT_REGULAR: 400,
  FONT_WEIGHT_BOLD: 600,
  HEADER_HEIGHT: 120,
  HEADER_HEIGHT_MOBILE: 80,
  CONTENT_PADDING_VERTICAL: 40,
  Z_INDEX_HEADER: 9998,
  Z_INDEX_HEADER_NAV: 9989,
}
